var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.00001 0C8.88115 0 10.646 0.746371 11.9497 2.05029C12.185 2.28544 12.4029 2.53661 12.6018 2.80176L12.6 1.40002C12.6 1.04104 12.8703 0.745146 13.2184 0.704721L13.3 0.700034C13.659 0.700034 13.9549 0.970257 13.9953 1.31838L14 1.40002V4.9C14 5.25898 13.7298 5.55487 13.3817 5.5953L13.3 5.59999H9.80002C9.4134 5.59999 9.10003 5.28661 9.10003 4.89999C9.10003 4.54102 9.37025 4.24512 9.71838 4.20469L9.80002 4.20001L11.8511 4.2002C11.6064 3.77725 11.3068 3.38713 10.9598 3.04026C9.91594 1.99631 8.50609 1.40004 7.00005 1.40004C3.90731 1.40004 1.40007 3.90728 1.40007 7.00001C1.40007 10.0927 3.90731 12.6 7.00005 12.6C8.50609 12.6 9.91604 12.0037 10.9598 10.9598C11.4799 10.4397 11.8938 9.82247 12.1754 9.14338C12.3154 8.80568 12.4221 8.4544 12.4934 8.09368C12.5685 7.71438 12.9367 7.46781 13.3159 7.54281C13.6952 7.61781 13.9418 7.98606 13.8668 8.36535C13.7774 8.817 13.6439 9.25685 13.4687 9.6796C13.1164 10.529 12.5992 11.3003 11.9497 11.9497C10.6459 13.2536 8.88122 14 6.99998 14C3.13399 14 0 10.866 0 7.00004C0 3.13406 3.13402 0 7.00001 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.3a378b3a783e5bc5639b7b94bf558b70.svg";
export { ForwardRef as ReactComponent };